import { Schema as S } from "effect";

export const GetCardsFromTerminalRequestSchema = S.Struct({
  terminalId: S.String,
});

export type GetCardsFromTerminalRequest = S.Schema.Type<typeof GetCardsFromTerminalRequestSchema>;
